export enum CancellationReason {
  REJECTED_PHONE_SELFIE = "Rejected CX Selfie Review",
  SALE_EXPLICITLY_CANCELED = "Sale Explicitly Canceled",
  SALE_TIMED_OUT = "Sale Timed Out",
}
